
export interface Category {
  id: string;
  title: string;
  tagline: string;
  description: string[];
  items: string[];
  path?: string;
}

export const categories: Category[] = [
  {
    id: "projektentwicklung",
    title: "Projektentwicklung",
    tagline: "Visionen formen. Potenziale erkennen. Werte schaffen.",
    description: [
      "Wir identifizieren geeignete Standorte, entwickeln Nutzungskonzepte und analysieren Machbarkeit und Wirtschaftlichkeit. Dabei stehen städtebauliche Qualität, Marktgerechtigkeit und nachhaltige Wertschöpfung im Mittelpunkt. Unsere Projektentwicklung bildet das strategische Fundament für nachhaltigen Projekterfolg.",
    ],
    items: [
      "Standort- und Marktanalysen",
      "Nutzungskonzepte und Machbarkeitsstudien",
      "Projektkonzeption und Wirtschaftlichkeitsberechnungen ",
      "Erstellung eines Finanzierungskonzepts und Begleitung ",
      "Abstimmung mit Städten, Gemeinden, Behörden und Partnern",
      "Entwicklung von Wohn-, Hotel- und Sonderimmobilien",
      "Erstellung eines Energiekonzeptes für eine Nachhaltigkeitszertifizierung der jeweiligen Bauobjekte",
    ],
  },
   {
    id: "projektmanagement",
    title: "Projektmanagement",
    tagline: "Struktur schaffen. Prozesse lenken. Ziele sichern.",
    description: [
      "Wir übernehmen die Gesamtheit von Führungsaufgaben und -organisation komplexer Bauvorhaben und das termin-, kosten- und qualitätsgerecht. Als zentrale Schnittstelle zwischen allen Beteiligten sorgen wir für einen reibungslosen Ablauf und transparente Entscheidungsprozesse.",
    ],
    items: [
      "Projektorganisation und Terminplanung",
      "Kosten- und Qualitätsmanagement",
      "Steuerung von Planungs- und Genehmigungsprozessen",
      "Vertrags- und Vergabemanagement",
      "Risikomanagement und Berichtswesen",
    ],
  },
  {
    id: "projektleitung-steuerung",
    title: "Projektleitung und -steuerung",
    tagline: "Planung umsetzen. Verantwortung übernehmen. Ergebnisse liefern.",
    description: [
      "Wir begleiten das Projekt operativ im Tagesgeschäft – mit technischem Know-how, Erfahrung, Entscheidungsstärke und Unterstützung durch das Building Information Modeling (BIM). Unser Projektsteuerung gewährleistet eine effiziente Umsetzung Ihrer Ziele in allen HOAI-Leistungsphasen und über alle Gewerke.",
    ],
    items: [
      "Projektleitung der nicht delegierbaren Aufgaben der Bauherrenseite mit Entscheidung- und Durchsetzungskompetenz",
      "Führen von Vergabeverhandlungen und Empfehlung an den Bauherren",
      "Steuerung von Projekten mit mehreren Fachbereichen in Stabsfunktion Firmen",
      "Führen von Planungs- und Baubesprechungen",
      "Bauablaufkoordination und Qualitätssicherung",
      "Projektcontrolling",
      "Budgetüberwachung und Nachtragsmanagement",
      "Ausführungsvorbereitung und Ausführung",
      "Übergabe, Abnahmen und Mängelverfolgung",
    ],
  },
  {
    id: "vertrieb-und-vermarktung",
    title: "Vertrieb und Vermarktung",
    tagline: "Erfolg am Markt – strategisch positioniert und überzeugend präsentiert.",
    description: [
      "Wir beraten und begleiten die Vermarktungsphase mit einem klaren Konzept, fundierter Marktkenntnis und zielgerichteter Kommunikation.",
      "Beispiele dafür sind Spezialimmobilien wie Hotels oder Objekte des betreuten Wohnens, bei denen wir den Bauherren unterstützen geeignete Betreiber vertraglich zu binden.",
    ],
    items: [
      "Entwicklung von Vermarktungsstrategien insbesondere für Wohnprojekte",
      "Unterstützung bei der Auswahl und Steuerung von Vertriebspartnern",
      "Begleitung von Verkaufsprozessen ",
      "Erstellung vertriebsrelevanter Unterlagen und Exposés",
      "Abstimmung mit Notaren, Banken und Kaufinteressenten",
    ],
  },
  {
    id: "objektbetreuung-gewahrleistungsmanagement",
    title: "Objektbetreuung & Gewährleistungsmanagement",
    tagline: "Verantwortung endet nicht mit der Schlüsselübergabe.",
    description: [
      "Auch nach Fertigstellung und um den Projekterfolg dauerhaft zu sichern, begleiten wir Projekte, die sich noch in der Gewährleistungsphase befinden, verlässlich weiter. In der Gewährleistungsphase stehen wir als Ansprechpartner für Eigentümer, Nutzer und Dienstleister zur Verfügung – mit dem Ziel, einen reibungslosen Betrieb und nachhaltige Zufriedenheit sicherzustellen.",
      "Bei Bedarf kann der Bauherr für den weiteren Lebenszyklus seiner Immobilie auch die technische Betreuung und Instandhaltung in unsere Hände legen. Technische Gutachten und Schadensgutachten runden das Leistungsportfolio für Bestandsimmobilien ab.",
    ],
    items: [
      "Koordination von Mängelbearbeitung und Nachunternehmern",
      "Organisation von Übergaben, Begehungen und Dokumentationen",
      "Kommunikation mit Käufern, Nutzern und Hausverwaltungen",
      "Unterstützung bei technischen Rückfragen oder Betriebsanlauf",
    ],
  },
 {
    id: "veranstaltungsorganisation-fur-bauprojekte",
    title: "Veranstaltungsorganisation für Bauprojekte",
    tagline: "Meilensteine feiern – professionell inszeniert.",
    description: [
      "Ob Grundsteinlegung, Richtfest oder feierliche Projektübergabe – wir organisieren bedeutende Projektmeilensteine mit Sorgfalt, Stil und dem richtigen Gespür für die Zielgruppe unserer Auftraggeber. Als Bauherr oder Projektpartner können Sie sich auf einen reibungslosen Ablauf und einen professionellen Auftritt verlassen.",
      "Wir schaffen den passenden Rahmen, um die Erfolge unserer Bauherren sichtbar und erlebbar zu machen – für Gäste, Partner, Öffentlichkeit und Medien.",
    ],
    items: [
      "Konzeption, Planung und Organisation von Grundsteinlegungen und Richtfesten",
      "Abstimmung mit Behörden, Partnern, Rednern, Gästen und Dienstleistern",
      "Entwicklung von Redebeiträgen, Ablaufplänen und Pressematerialien",
      "Koordination vor Ort inklusive Technik, Catering und Ausstattung",
      "Begleitung der Kommunikation in Abstimmung mit PR- oder Marketingteams",
    ],
  },
];



export type ServiceId =
  | "projektentwicklung"
  | "projektleitung-steuerung"
  | "projektmanagement"
  | "vertrieb-und-vermarktung"
  | "objektbetreuung-gewahrleistungsmanagement"
  | "veranstaltungsorganisation-fur-bauprojekte";

export interface ServiceLink {
  id: ServiceId;
  path: string;   
  title: string;
  tagline?: string;
}


export const servicesNav: ServiceLink[] = categories.map((c) => ({
  id: c.id as ServiceId,
  path: c.path ?? c.id,
  title: c.title,
  tagline: c.tagline,
}));

export const categoryById = new Map(categories.map((c) => [c.id, c]));
